module.exports = __webpack_public_path__ + "media/images/app/products/index/styles/necklaces/pendant-3329c5dc0391209d37d3c1c689b827ea.webp";